export const VenmoLogoIcon = ({ width, height, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 48}
      height={height || 29}
      viewBox="0 0 48 32"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <rect fill="#3D95CE" width="47.4074074" height="31.6049383" rx="3.16049383"/>
        <path d="M33.1851852,10.1131555 C33.1851852,14.8373944 29.2425262,20.9745161 26.0425868,25.2839506 L18.7337285,25.2839506 L15.8024691,7.35534396 L22.202175,6.73384536 L23.7519727,19.4912014 C25.2000422,17.0781163 26.9870326,13.2859484 26.9870326,10.7005 C26.9870326,9.28531656 26.7500128,8.32139205 26.3796046,7.52770719 L32.207522,6.32098765 C32.8813847,7.45939896 33.1851852,8.63196439 33.1851852,10.1131555 Z" fill="#FFF"/>
      </g>
    </svg>
  );
};
